import { ColumnDetails } from "components/TransportOrder/OrderOverview"

export enum Column {
    TRANSPORT_ORDER_NUMBER = "TRANSPORT_ORDER_NUMBER",
    TRANSPORT_ORDER_ID = "TRANSPORT_ORDER_ID",
    TRANSPORT_ORDER_BUNDLE_ID = "TRANSPORT_ORDER_BUNDLE_ID",
    FREIGHT_FORWARDER_ACCOUNT_ID = "FREIGHT_FORWARDER_ACCOUNT_ID",
    FREIGHT_FORWARDER = "FREIGHT_FORWARDER",
    SUPPLIER = "SUPPLIER",
    BUYER = "BUYER",
    CONSIGNOR = "CONSIGNOR",
    CONSIGNEE = "CONSIGNEE",
    CREATED_AT = "CREATED_AT",
    CONFIRMED_AT = "CONFIRMED_AT",
}

export const columns = [
    Column.TRANSPORT_ORDER_NUMBER,
    Column.TRANSPORT_ORDER_ID,
    Column.TRANSPORT_ORDER_BUNDLE_ID,
    Column.FREIGHT_FORWARDER_ACCOUNT_ID,
    Column.FREIGHT_FORWARDER,
    Column.SUPPLIER,
    Column.BUYER,
    Column.CONSIGNOR,
    Column.CONSIGNEE,
    Column.CREATED_AT,
    Column.CONFIRMED_AT,
]

type ColumnToDetailsMap = { [K in keyof typeof Column]: ColumnDetails }

export const columnDetailsByColumn: ColumnToDetailsMap = {
    [Column.TRANSPORT_ORDER_NUMBER]: {
        label: "rio.admin.transportOrder.transportOrderNumber",
    },
    [Column.TRANSPORT_ORDER_ID]: {
        label: "rio.admin.transportOrder.transportOrderId",
    },
    [Column.TRANSPORT_ORDER_BUNDLE_ID]: {
        label: "rio.admin.transportOrder.transportOrderBundleId",
    },
    [Column.FREIGHT_FORWARDER_ACCOUNT_ID]: {
        label: "rio.admin.transportOrder.freightForwarderAccountId",
    },
    [Column.FREIGHT_FORWARDER]: {
        label: "rio.admin.transportOrder.freightForwarder",
    },
    [Column.SUPPLIER]: {
        label: "rio.admin.transportOrder.supplier",
    },
    [Column.BUYER]: {
        label: "rio.admin.transportOrder.buyer",
    },
    [Column.CONSIGNOR]: {
        label: "rio.admin.transportOrder.consignor",
    },
    [Column.CONSIGNEE]: {
        label: "rio.admin.transportOrder.consignee",
    },
    [Column.CREATED_AT]: {
        label: "rio.admin.transportOrder.createdAt",
    },
    [Column.CONFIRMED_AT]: {
        label: "rio.admin.transportOrder.confirmedAt",
    },
}
